import { injectable } from 'inversify';
import { unit_option_availability_full } from '@Api';
import {
  Nullable,
  UnitOptionAvailability,
  UnitOptionAvailabilityAction,
  UnitOptionAvailabilityActivator,
  UnitOptionUsePoint,
} from '@Models';
import { unit_option_full } from '@Api';

@injectable()
export class UnitOptionAvailabilityMapper {
  public map(
    unitOptionId: number,
    item: unit_option_availability_full,
  ): UnitOptionAvailability {
    return {
      id: item.id,
      modifierId: unitOptionId,
      activator: this.mapActivator(item.activator),
      action: this.mapAction(item.action),
      armyOrganisationId: item.army_organisation_id,
      unitId: item.unit_id,
      unitOptionId: item.unit_option_id,
      sizeMin: item.size_min,
      usePoints: this.mapUsePoints(item.use_points),
      value: item.value,
    } satisfies UnitOptionAvailability as UnitOptionAvailability;
  }

  public mapAction(
    item: unit_option_availability_full.action,
  ): UnitOptionAvailabilityAction {
    switch (item) {
      case unit_option_availability_full.action.DISABLE:
        return UnitOptionAvailabilityAction.Disable;
      case unit_option_availability_full.action.AUTO_SELECT:
        return UnitOptionAvailabilityAction.AutoSelect;
      case unit_option_availability_full.action.CHANGE_POINTS:
        return UnitOptionAvailabilityAction.ChangePoints;
      case unit_option_availability_full.action.CHANGE_CHOISE_LIMIT:
        return UnitOptionAvailabilityAction.ChangeChoiseLimit;
      case unit_option_availability_full.action.CHANGE_ENCHANTMENT_LIMIT:
        return UnitOptionAvailabilityAction.ChangeEnchantmentLimit;
    }
    return UnitOptionAvailabilityAction.Enable;
  }

  public mapUsePoints(
    item: Nullable<unit_option_full.use_points>,
  ): Nullable<UnitOptionUsePoint> {
    switch (item) {
      case unit_option_full.use_points.COST:
        return UnitOptionUsePoint.Cost;
      case unit_option_full.use_points.NO_COST:
        return UnitOptionUsePoint.NoCost;
      case unit_option_full.use_points.FREE:
        return UnitOptionUsePoint.Free;
      case unit_option_full.use_points.NO_LIMIT:
        return UnitOptionUsePoint.NoLimit;
      case unit_option_full.use_points.UP_TO:
        return UnitOptionUsePoint.UpTo;
    }
    return null;
  }

  mapActivator(
    item: unit_option_availability_full.activator,
  ): UnitOptionAvailabilityActivator {
    switch (item) {
      case unit_option_availability_full.activator.OTHER_UNIT:
        return UnitOptionAvailabilityActivator.OtherUnit;
      case unit_option_availability_full.activator.ARMY_ORGANISATION:
        return UnitOptionAvailabilityActivator.ArmyOrganisation;
      case unit_option_availability_full.activator.SIZE_MIN:
        return UnitOptionAvailabilityActivator.SizeMin;
    }
    return UnitOptionAvailabilityActivator.SameUnit;
  }
}
